import { render, staticRenderFns } from "./supplier-payment.vue?vue&type=template&id=c36dd7ba"
import script from "./supplier-payment.vue?vue&type=script&lang=js"
export * from "./supplier-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports